var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 40,
    viewBox: "0 0 28 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9922 0C6.28092 0 0.00915527 6.27567 0.00915527 13.9869C0.00915527 22.952 11.9414 37.5151 12.4493 38.1291L13.9922 40L15.535 38.1291C16.0429 37.5131 27.9752 22.952 27.9752 13.9869C27.9752 6.27367 21.7034 0 13.9922 0ZM13.9922 3.99961C19.4976 3.99961 23.9756 8.48145 23.9756 13.9869C23.9756 19.3964 17.7478 28.7 13.9922 33.6295C10.2365 28.704 4.00876 19.4044 4.00876 13.9869C4.00876 8.48145 8.4867 3.99961 13.9922 3.99961ZM13.9922 8.97959C11.2304 8.97959 8.99265 11.2174 8.99265 13.9791C8.99265 16.7408 11.2304 18.9786 13.9922 18.9786C16.7539 18.9786 18.9917 16.7408 18.9917 13.9791C18.9917 11.2174 16.7539 8.97959 13.9922 8.97959Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMark);
export default __webpack_public_path__ + "static/media/location-mark.f2a43bfd.svg";
export { ForwardRef as ReactComponent };